/* businesses */
export const LIST_ALL_EVENTS = "LIST_ALL_EVENTS"
export const LIST_ALL_EVENTS_SUCCESS = "LIST_ALL_EVENTS_SUCCESS"
export const LIST_ALL_EVENTS_ERROR = "LIST_ALL_EVENTS_ERROR"
export const LIST_ALL_EVENTS_CLEAN = "LIST_ALL_EVENTS_CLEAN"
